import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { createFilterValues, filterItems, createFilterClassName, shouldHideFilterControls } from './FilteredList.utils';
import { ObjectPropsPropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import { createComponent } from '../../services/components';
import { ChildrenPropType } from '../../types/component';
var defaultProps = {
  itemComponent: null,
  parentContainer: null,
  defaultFilterValue: '',
  displayAllFilterValue: '',
  filterValueKey: '',
  filterValuesComponent: /*#__PURE__*/React.createElement("div", null),
  className: ''
};
export default function FilteredList(_ref) {
  var items = _ref.items,
    itemFilterKey = _ref.itemFilterKey,
    childItemsKey = _ref.childItemsKey,
    filterValues = _ref.filterValues,
    itemComponent = _ref.itemComponent,
    parentContainer = _ref.parentContainer,
    defaultFilterValue = _ref.defaultFilterValue,
    displayAllFilterValue = _ref.displayAllFilterValue,
    filterValueKey = _ref.filterValueKey,
    filterValuesComponent = _ref.filterValuesComponent,
    className = _ref.className,
    children = _ref.children;
  var finalFilters = createFilterValues(filterValues, items, itemFilterKey, {
    displayAllFilterValue: displayAllFilterValue,
    filtersKey: filterValueKey
  });
  var _useState = useState(defaultFilterValue),
    _useState2 = _slicedToArray(_useState, 2),
    currentFilter = _useState2[0],
    setCurrentFilter = _useState2[1];
  var filteredItems = filterItems(items, itemFilterKey, currentFilter, displayAllFilterValue);
  var childrenWithProps = React.Children.map(children, function (child) {
    return createComponent(child, _defineProperty({}, childItemsKey, filteredItems));
  });
  if (itemComponent) {
    childrenWithProps = filteredItems.map(function (item) {
      return createComponent(itemComponent, _defineProperty({}, childItemsKey, item));
    });
  }
  function createChildren() {
    if (parentContainer) {
      return createComponent(parentContainer, {
        children: childrenWithProps
      });
    }
    return childrenWithProps;
  }
  var hideFilters = shouldHideFilterControls(finalFilters, items, itemFilterKey, {
    displayAllFilterValue: displayAllFilterValue
  });
  var finalClassName = classNames(_defineProperty({
    'filtered-list': true,
    'no-filters': hideFilters
  }, className, className));
  if (_isEmpty(items)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: finalClassName
  }, !hideFilters && /*#__PURE__*/React.createElement("div", {
    className: "filter-controls"
  }, finalFilters.map(function (filter) {
    return createComponent(filterValuesComponent, {
      key: filter,
      className: createFilterClassName(currentFilter === filter),
      onClick: function onClick() {
        return setCurrentFilter(filter);
      },
      children: filter
    });
  })), createChildren());
}
FilteredList.defaultProps = defaultProps;